import React from 'react';
import { differenceInCalendarDays, format } from 'date-fns';
import { connect } from 'react-redux';

import { SERVER_DATE_FORMAT } from 'constants/logic';
import { getTodayInVenueTimezone } from 'features/Schedules/ScheduleCalendar/ScheduleCalendar.helpers';
import Segment from 'helpers/segment';
import { selectActiveVenue, selectSchedulesStartDate } from 'selectors/general';
import { selectIsDesktop } from 'selectors/ui';

import { VenueSchedulesContextProvider } from './Contexts/VenueSchedulesContext';
import YieldManagement from './YieldManagement';
import { updateStartDate as updateStartDateAction } from './YieldManagement.saga';

const YieldManagementWithProvider = props => (
  <VenueSchedulesContextProvider>
    <YieldManagement {...props} />
  </VenueSchedulesContextProvider>
);

const mapStateToProps = (state, ownProps) => {
  const { venueId, timezone: venueTimezone } = selectActiveVenue(state, ownProps);
  const schedulesStartDate = selectSchedulesStartDate(state);
  const isDesktop = selectIsDesktop(state);

  return {
    isDesktop,
    venueId,
    venueTimezone,
    startDate: schedulesStartDate,
    startDateFormatted: format(schedulesStartDate, SERVER_DATE_FORMAT),
  };
};

const mapDispatchToProps = {
  updateStartDateAction,
};

export const mergeProps = (stateProps, dispatchProps) => {
  const { venueTimezone, ...restStateProps } = stateProps;
  const { venueId } = restStateProps;

  return {
    ...restStateProps,
    updateStartDate: startDate => {
      Segment.event('Click Date Filter', {
        venueId,
        date_range: differenceInCalendarDays(startDate, getTodayInVenueTimezone(venueTimezone)),
      });
      dispatchProps.updateStartDateAction(startDate);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(YieldManagementWithProvider);
